import React, { Fragment, useEffect, useState } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Link, Typography } from '@material-ui/core';
import settings from '../../utils/settings';
import {
  onlyForUS,
  onlyForAU,
  onlyForNZ,
  onlyForNC,
  onlyForDE,
  onlyForNL,
  onlyForBE,
  onlyForMX,
  onlyForBR,
  onlyForIN,
  onlyForFr,
  onlyForEs,
  onlyForAT,
  onlyForCA,
  onlyForCH,
  onlyForPT,
  onlyForDK,
  onlyForSE,
  onlyForGR,
  onlyForZA,
  viewOnlyDisabledLabels,
  selfInstallerLabels
} from '../Breadcrumb/constant';
import analytics from '../../utils/analytics';
import { getToken, getCountryBasedLink, constructUrlWithParams, isEnlm, reDirectTo } from '../../utils/helper';
import { flatten, get, isEmpty, isEqual } from 'lodash';
import I18n from '../../config/locales';
import feature from '../../utils/feature';
import { getPlatformBasedUrl } from '../../config/platformBasedUrls/url';
import SolargrafPopupFlow from '../Solargraf/SolargrafPopupFlow';
import { setSolargrafPopupDetails } from '../../containers/Layouts/actions';

const useStyles = makeStyles((theme) => ({
  list: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.25, 0)
  },
  listLink: {
    color: `${theme.palette.tertiary.main} !important`,
    cursor: 'pointer !important',
    marginLeft: `${theme.spacing(1.25)}px !important`,
    display: 'flex !important',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  bullets: {
    width: theme.spacing(1.25),
    height: theme.spacing(1.25),
    borderRadius: theme.spacing(1.25),
    backgroundColor: theme.palette.secondary.dark
  },
  comingSoon: {
    color: '#AAA9A9 !important',
    pointerEvents: 'none'
  },
  comingSoonLabel: {
    background: '#A5A5A5 0% 0% no-repeat padding-box',
    letterSpacing: '0 !important',
    lineHeight: '0 !important',
    color: theme.palette.secondary.main,
    textTransform: 'uppercase',
    height: theme.spacing(1.5),
    fontSize: '9px !important',
    display: 'flex',
    fontWeight: 'bold',
    alignItems: 'center',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(0, 0.5),
    whiteSpace: 'nowrap'
  },
  submenuLink: {
    borderBottom: '1px solid #70707036',
    '&:last-child': {
      border: 'none'
    }
  },
  newLabel: {
    background: '#FF7141 0% 0% no-repeat padding-box',
    letterSpacing: '0 !important',
    lineHeight: '0 !important',
    color: theme.palette.secondary.main,
    textTransform: 'uppercase',
    height: theme.spacing(1.5),
    fontSize: '9px !important',
    display: 'flex',
    fontWeight: 'bold',
    alignItems: 'center',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(0, 0.5),
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing(1.5)
  }
}));

const AccountList = (props) => {
  const gaAnalytics = new analytics();
  const {
    accountList,
    companyId,
    leadOptIn,
    title,
    state,
    abLreEnabled,
    abPermitEnabled,
    abBOMEnabled,
    abSgipEnabled,
    enlightenManagerToken,
    asSubMenu = false,
    einOptIn = false,
    hasTier = false,
    abEinMerchandise,
    companyInfo,
    dashboardLinks,
    countryCode,
    einOptOut,
    pathName,
    searchParam = '',
    accountData,
    isHardLoad = false,
    featureList,
    viewOnlyAccess,
    handleCloseTooltip = () => {},
    setSolargrafPopupDetails,
    fromITK,
    solargrafAccess,
    setSolargrafAccess,
    forwardTo,
    isAuthorizedSubcontractor,
    generatorTokensEnabled,
    dataPlanExtensionEnabled
    // showBomDialog = () => {}
  } = props;

  const belongsToAus = isEqual(countryCode, 'AU');
  const belongsToDe = isEqual(countryCode, 'DE');
  const belongsToBe = isEqual(countryCode, 'BE');
  const belongsToNl = isEqual(countryCode, 'NL');
  const belongsToIn = isEqual(countryCode, 'IN');
  const belongsToMx = isEqual(countryCode, 'MX');
  const belongsToUs = isEqual(countryCode, 'US');
  const belongsToNc = isEqual(countryCode, 'NC');
  const belongsToFr = isEqual(countryCode, 'FR');
  const belongsToBr = isEqual(countryCode, 'BR');
  const belongsToNz = isEqual(countryCode, 'NZ');
  const belongsToEs = isEqual(countryCode, 'ES');
  const belongsToAt = isEqual(countryCode, 'AT');
  const belongsToCa = isEqual(countryCode, 'CA');
  const belongsToCh = isEqual(countryCode, 'CH');
  const belongsToPT = isEqual(countryCode, 'PT');
  const belongsToDK = isEqual(countryCode, 'DK');
  const belongsToSE = isEqual(countryCode, 'SE');
  const belongsToGR = isEqual(countryCode, 'GR');
  const belongsToZA = isEqual(countryCode, 'ZA');
  const classes = useStyles();
  const isAcmAdmin = get(accountData, 'is_acm_admin', false);
  const isEinOptOut = get(companyInfo, 'ein_opt_out', false) || einOptOut;
  const isSelfInstaller = get(accountData, 'self_installer', false);
  const isSolargrafEnabled = !isEmpty(featureList) ? feature.isFeatureEnabled('SOLARGRAF_ENABLED') : false;
  const abRMADashboardEnabled = !isEmpty(featureList) ? feature.isFeatureEnabled('RMA_DASHBOARD') : false;
  const isDRSFeatureEnabled = isSelfInstaller ? feature.isFeatureEnabled('DRS_ENABLED_USER') : feature.isFeatureEnabled('DRS_ENABLED_COMPANY');
  const isEVSEIncentivesToolEnabled = feature.isFeatureEnabled('EVSE_INCENTIVES_TOOL')

  const drsCountryABFlagMap = {
    AU: 'DRS_AUSTRALIA_LAUNCH',
    DE: 'DRS_GERMANY_LAUNCH',
    BE: 'DRS_BELGIUM_LAUNCH',
    MX: 'DRS_MEXICO_LAUNCH',
    US: 'DRS_ENABLED_COMPANY',
    AT: 'DRS_AUSTRIA_LAUNCH',
    CA: 'DRS_CANADA_LAUNCH',
    FR: 'DRS_FRANCE_LAUNCH',
    NL: 'DRS_NETHERLANDS_LAUNCH',
    CH: 'DRS_SWITZERLAND_LAUNCH',
    ES: 'DRS_SPAIN_LAUNCH',
    PT: 'DRS_PORTUGAL_LAUNCH',
    DK: 'DRS_DENMARK_LAUNCH',
    SE: 'DRS_SWEDEN_LAUNCH',
    GR: 'DRS_GREECE_LAUNCH',
    ZA: 'DRS_SOUTH_AFRICA_LAUNCH',
    NZ: 'DRS_NEW_ZEALAND_LAUNCH',
  };

  const isDRSEnabled = () => {
    if (belongsToUs) {
      return !isEmpty(featureList) && isDRSFeatureEnabled;
    }
    return !isEmpty(featureList) && feature.isFeatureEnabled(get(drsCountryABFlagMap, countryCode));
  };

  const { navigateToManager = false, name, isExternalLink = false, label, isComingSoon = false } = accountList;
  const is_self_installer_grid_profile_enabled = !isEmpty(featureList) && feature.isFeatureEnabled('GRID_PROFILE_SELF_INSTALLER_FEATURE_ID');
  const isDRSLabel = label === 'design-review';
  let isDisabledLabel = false;
  let url = accountList.url;

  while (url && url.includes(':company_id')) {
    url = url.replace(':company_id', companyId);
  }

  const show_link = get(dashboardLinks, 'ein.show_link', false);

  const [navigationLink, setNavigationLink] = useState(url);
  useEffect(() => {
    const getNavigationLink = (label, url) => {
      const token = getToken() || enlightenManagerToken;
      switch (label) {
        case 'enphase_store':
          return getCountryBasedLink('enphaseStore');
        case 'product-warranty-extension':
          return `${getCountryBasedLink('productWarrantyExtension')}&token=${token}`;
        default:
          return url;
      }
    };
    const breadcrumbPath = pathName && pathName.includes('account') ? 'account' : 'dashboard';
    const urlPath = `/manager/${breadcrumbPath}/${url}`;
    const notNavigateToManager = isExternalLink ? getNavigationLink(label, url) : urlPath;
    const link = navigateToManager ? settings.enlightenMenuUrl(url) : notNavigateToManager;
    setNavigationLink(constructUrlWithParams(link, searchParam));
  }, [countryCode, enlightenManagerToken, isExternalLink, label, navigateToManager, pathName, url, searchParam]);
  if (label === 'ac-module-admin' && !isAcmAdmin) {
    return null;
  }

  if (label === 'lead-program' && !leadOptIn) {
    return null;
  }

  if (label === 'enphase_store' && (belongsToIn || belongsToMx || belongsToBr)) {
    return null;
  }

  if (label === 'ein-merchandise' && !(abEinMerchandise && einOptIn && hasTier && belongsToUs && !fromITK)) {
    return null;
  }

  if (label === 'design-tool' && !isSolargrafEnabled) {
    return null;
  }

  if (label === 'authorized-subcontractor' && !isAuthorizedSubcontractor) {
    return null;
  }
  if (label === 'rma-dashboard' && !abRMADashboardEnabled) {
    return null;
  }
  if (label === 'generator-tokens' && !generatorTokensEnabled) {
    return null;
  }
  if (label === 'request_system_access' && isSelfInstaller) {
    return null;
  }
  if (label === 'data-plan-extension' && !dataPlanExtensionEnabled) {
    return null;
  }
  if (label === 'evse-incentives-tool' && !isEVSEIncentivesToolEnabled) {
    return null;
  }
  if (label === 'area-coverage' && !show_link) {
    return null;
  }
  if (label === 'ein-program' && !show_link) {
    return null;
  }
  if(label === 'company' && !accountData?.can_manage_company){
    return null;
  }
  const allCountryWiseLabel = new Set(
    flatten([
      onlyForUS,
      onlyForAU,
      onlyForNZ,
      onlyForNC,
      onlyForDE,
      onlyForNL,
      onlyForBE,
      onlyForMX,
      onlyForBR,
      onlyForIN,
      onlyForFr,
      onlyForEs,
      onlyForAT,
      onlyForCA,
      onlyForCH,
      onlyForPT,
      onlyForDK,
      onlyForSE,
      onlyForGR,
      onlyForZA,
    ])
  );

  const hideDisabledDRS = (labelInCountry) => {
    return isDRSLabel ? isDRSEnabled() && labelInCountry : labelInCountry;
  };

  const labelInUs = hideDisabledDRS(onlyForUS.includes(label) && belongsToUs);
  const labelInAus = hideDisabledDRS(onlyForAU.includes(label) && belongsToAus);
  const labelInNz = hideDisabledDRS(onlyForNZ.includes(label) && belongsToNz);
  const labelInNc = hideDisabledDRS(onlyForNC.includes(label) && belongsToNc);
  const labelInDe = hideDisabledDRS(onlyForDE.includes(label) && belongsToDe);
  const labelInNl = hideDisabledDRS(onlyForNL.includes(label) && belongsToNl);
  const labelInBe = hideDisabledDRS(onlyForBE.includes(label) && belongsToBe);
  const labelInMx = hideDisabledDRS(onlyForMX.includes(label) && belongsToMx);
  const labelInBr = hideDisabledDRS(onlyForBR.includes(label) && belongsToBr);
  const labelInIn = hideDisabledDRS(onlyForIN.includes(label) && belongsToIn);
  const labelInFr = hideDisabledDRS(onlyForFr.includes(label) && belongsToFr);
  const labelInEs = hideDisabledDRS(onlyForEs.includes(label) && belongsToEs);
  const labelInAt = hideDisabledDRS(onlyForAT.includes(label) && belongsToAt);
  const labelInCa = hideDisabledDRS(onlyForCA.includes(label) && belongsToCa);
  const labelInCh = hideDisabledDRS(onlyForCH.includes(label) && belongsToCh);
  const labelInPT = hideDisabledDRS(onlyForPT.includes(label) && belongsToPT);
  const labelInDK = hideDisabledDRS(onlyForDK.includes(label) && belongsToDK);
  const labelInSE = hideDisabledDRS(onlyForSE.includes(label) && belongsToSE);
  const labelInGR = hideDisabledDRS(onlyForGR.includes(label) && belongsToGR);
  const labelInZA = hideDisabledDRS(onlyForZA.includes(label) && belongsToZA);
  if (
    [...allCountryWiseLabel].includes(label) &&
    !(
      labelInUs ||
      labelInAus ||
      labelInNz ||
      labelInNc ||
      labelInDe ||
      labelInNl ||
      labelInBe ||
      labelInMx ||
      labelInBr ||
      labelInIn ||
      labelInFr ||
      labelInEs ||
      labelInAt ||
      labelInCa ||
      labelInCh ||
      labelInPT ||
      labelInDK ||
      labelInSE ||
      labelInGR ||
      labelInZA
    )
  ) {
    return null;
  }

  if (isSelfInstaller && !selfInstallerLabels.includes(label)) {
    return null;
  }
  if (label === 'profiles' && ((isSelfInstaller && !is_self_installer_grid_profile_enabled) || (!isSelfInstaller && !accountData?.can_manage_company))) {
    return null;
  }
  if (label === 'labor-protection' && ((belongsToUs && ['PR'].includes(state)) || !abLreEnabled)) {
    isDisabledLabel = true;
  }
  if (label === 'sgip-incentive' && (!belongsToUs || !abSgipEnabled)) {
    isDisabledLabel = true;
  }
  if (label === 'permitting-assistance' && (!belongsToUs || !abPermitEnabled)) {
    isDisabledLabel = true;
  }
  if (label === 'bom-calculator' && (!belongsToUs || !abBOMEnabled)) {
    isDisabledLabel = true;
  }
  if (label === 'ein-program' && isEinOptOut) {
    isDisabledLabel = true;
  }
  if (isDRSLabel && !isDRSEnabled()) {
    isDisabledLabel = true;
  }
  // though drs is external link we need to open it in same tab
  const target = isExternalLink && label !== 'design-review' ? '_blank' : '_self';
  const hasComingSoonLabel = isComingSoon || isDisabledLabel;
  const disabledLinks = viewOnlyAccess && viewOnlyDisabledLabels.includes(label);
  const linkClass = clsx(classes.listLink, (hasComingSoonLabel || disabledLinks) && classes.comingSoon);

  const comingSoonLabel = (
    <Fragment>
      {I18n.t(`accountInfo.${name}`)}
      <Typography className={classes.comingSoonLabel}>{I18n.t('header.comingSoon')}</Typography>
    </Fragment>
  );

  const link = I18n.t(`accountInfo.${name}`);

  const listName = hasComingSoonLabel ? comingSoonLabel : link;

  const events = {
    event: 'triggerMenuList'
  };
  const trackEvent = (listName) => {
    const dataLayer = {
      menuName: title,
      menuValue: listName
    };
    gaAnalytics.triggerEvent(events, dataLayer);
  };
  const hardLoad = isHardLoad || label === 'labor-protection' || label === 'lead-program' || label === 'permitting-assistance';

  const designTool = () => {
    asSubMenu && handleCloseTooltip();
    trackEvent(asSubMenu ? listName + ' dropdown' : listName);
    setSolargrafPopupDetails({
      startSolargrafPopupFlow: true,
      solargrafAccessAction: '',
      linkWithSolargrafSuccess: ''
    });
  };

  const handleNavigation = (cbkFunction) => {
    cbkFunction();
    asSubMenu && handleCloseTooltip();
  };

  const handleDrs = () => {
    const token = getToken() || enlightenManagerToken;
    const link = navigationLink
    trackEvent(asSubMenu ? listName + ' dropdown' : listName);
    isEnlm() ? window.location.replace(settings.drsUiUrl('manager/dashboard/' + link)) : forwardTo('/manager/dashboard/design-review');
  };

  const renderAccountList = () => {
    let accountListName = '';
    switch (true) {
      case hasComingSoonLabel:
        accountListName = (
          <Typography component="div" className={linkClass}>
            {listName}
          </Typography>
        );
        break;
      case label === 'design-tool':
        accountListName = (
          <Typography className={linkClass} component="div" onClick={() => designTool()}>
            {listName}
          </Typography>
        );
        break;
      case label === 'design-review':
        accountListName = (
          <Typography className={linkClass} component="div" onClick={handleDrs}>
            {listName}
          </Typography>
        );
        break;
      case label === 'bom-calculator':
        accountListName = (
          <Typography
            className={linkClass}
            component="div"
            onClick={() => {
              gaAnalytics.triggerEvent(
                { event: 'triggerBomEnlighten' },
                {
                  menuValue: asSubMenu
                    ? 'entrypoint_services_menu'
                    : 'entrypoint_services',
                }
              );
              window.location.replace(
                settings.getEnphaseUiUrl('/installers/systems')
              );
            }}
          >
            {listName}
          </Typography>
        );
        break;
      case isExternalLink:
      case navigateToManager:
        accountListName = (
          <Link
            href={navigationLink}
            className={linkClass}
            target={target}
            onClick={() => handleNavigation(() => trackEvent(asSubMenu ? `${listName} dropdown` : listName))}
          >
            {listName}
          </Link>
        );
        break;
      default:
        accountListName = (
          <Link
            className={linkClass}
            onClick={() => {
              isEnlm() && !hardLoad ? forwardTo(navigationLink) : reDirectTo(navigationLink);
              handleNavigation(() => trackEvent(asSubMenu ? `${listName} dropdown` : listName));
            }}
          >
            {listName}
          </Link>
        );
        break;
    }
    return (
      <Fragment>
        {accountListName}
        {['sgip-incentive', 'permitting-assistance', 'generator-tokens', 'data-plan-extension', 'evse-incentives-tool'].includes(label) && !hasComingSoonLabel && (
          <Typography className={classes.newLabel}>{I18n.t('accountInfo.new')}</Typography>
        )}
      </Fragment>
    );
  };

  if (asSubMenu) {
    let subMenuLinkClass = clsx(classes.list, classes.submenuLink);
    return (
      <Typography component="div" className={subMenuLinkClass}>
        {renderAccountList()}
      </Typography>
    );
  }

  return (
    <Typography component="div" className={classes.list}>
      <Typography component="div" className={classes.bullets} />
      {renderAccountList()}
      {fromITK && (
        <SolargrafPopupFlow
          accountDetail={accountData}
          solargrafAccess={solargrafAccess}
          setSolargrafAccess={setSolargrafAccess}
          forwardTo={forwardTo}
        />
      )}
    </Typography>
  );
};

AccountList.propTypes = {
  companyInfo: PropTypes.object,
  countryCode: PropTypes.string,
  einOptOut: PropTypes.bool,
  accountData: PropTypes.object,
  viewOnlyAccess: PropTypes.bool,
  fromITK: PropTypes.bool,
  solargrafAccess: PropTypes.bool,
  setSolargrafAccess: PropTypes.func,
  forwardTo: PropTypes.func
};

const mapDispatchToProps = (dispatch) => ({
  setSolargrafPopupDetails: (payload) => dispatch(setSolargrafPopupDetails(payload))
});

const mapStateToProps = (state) => ({
  featureList: state.defaultReducer.featureList
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountList);
